export default __webpack_public_path__ + "static/media/agile.4355bc05.png";